import { render } from "./NewsletterConfirmation.vue?vue&type=template&id=ffdd6924&lang=pug"
import script from "./NewsletterConfirmation.vue?vue&type=script&lang=js"
export * from "./NewsletterConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__